export default __webpack_public_path__ + "static/media/ic_student.ba3cc365.svg";